import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "appointment" }
const _hoisted_2 = { class: "heading-title" }
const _hoisted_3 = { class: "heading-desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressIndicator = _resolveComponent("ProgressIndicator")!
  const _component_FormRow = _resolveComponent("FormRow")!
  const _component_Calendly = _resolveComponent("Calendly")!
  const _component_Button = _resolveComponent("Button")!
  const _component_PoweredBy = _resolveComponent("PoweredBy")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_FormRow, { class: "full-width" }, {
      default: _withCtx(() => [
        _createVNode(_component_ProgressIndicator, {
          currentStep: 3,
          steps: 4
        })
      ]),
      _: 1
    }),
    _createVNode(_component_FormRow, { class: "full-width" }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", null, _toDisplayString(_ctx.$t('appointment.heading')), 1)
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode("span", null, _toDisplayString(_ctx.$t('appointment.desc')), 1)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_FormRow, { class: "full-width" }, {
      default: _withCtx(() => [
        _createVNode(_component_Calendly, { onSuccess: _ctx.onAppointmentSuccess }, null, 8, ["onSuccess"])
      ]),
      _: 1
    }),
    _createVNode(_component_FormRow, { class: "full-width" }, {
      default: _withCtx(() => [
        _createVNode(_component_Button, {
          class: "full-width large white low-prio",
          onClick: _ctx.goToAppointmentContactSection
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('appointment.hadAlready')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }),
    _createVNode(_component_FormRow, { class: "full-width" }, {
      default: _withCtx(() => [
        _createVNode(_component_Button, {
          disabled: _ctx.disablePreviousButton,
          class: "full-width outlined",
          size: "large",
          onClick: _ctx.goToBackPage
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.previousStep')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      _: 1
    }),
    _createVNode(_component_FormRow, null, {
      default: _withCtx(() => [
        _createVNode(_component_PoweredBy)
      ]),
      _: 1
    })
  ]))
}